export default "__VITE_PUBLIC_ASSET__41ec27e9__"